import Rollbar from 'rollbar';

interface ErrorReporter {
  error: (...params: any[]) => void;
}

let reporterInstance: ErrorReporter;

export const createRollbarInstance = (
  accessToken: string,
  environment: 'qa' | 'staging' | 'production' | 'env4',
) => new Rollbar({
    accessToken,
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      environment: environment.toLowerCase(),
      client: {
        javascript: {
          source_map_enabled: true,
          code_version: process.env.APP_VERSION,
          guess_uncaught_frames: true,
        },
      },
    },
  });

export const setReporterInstance = (instance: ErrorReporter) => {
  reporterInstance = instance;
};

export default {
  error: (...args: any[]) => {
    if (reporterInstance) {
      reporterInstance.error(...args);
    }

    if (
      process.env.NODE_ENV === 'development' ||
      window.location.host === 'qa.brokerbay.ca' ||
      window.location.host === 'qa.brokerbay.com' ||
      window.location.host === 'staging.brokerbay.ca' ||
      window.location.host === 'staging.brokerbay.com'
    ) {
      console.error(...args);
    }
  },
};
